var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 139,
    viewBox: "0 0 302 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1193_4040)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.820312,
    y: 0.796875,
    width: 301,
    height: 138,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1193_4040)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301.456,
    height: 21.8799,
    transform: "translate(0.820312 0.796875)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 0.796875H87.1243V22.6768H0.820312V0.796875Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 0.796875H87.1243V22.6768H0.820312V0.796875Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.332 14.8496V15.7285H35.2656V14.8496H37.3555V13.0332H35.959V12.1543H37.1992V9.53711H35.9297V8.66797H42.6289V9.53711H41.3398V12.1543H42.5996V13.0332H41.2031V14.8496H43.332ZM38.2832 12.1543H40.2656V9.53711H38.2832V12.1543ZM38.4395 14.8496H40.1191V13.0332H38.4395V14.8496ZM51.2324 8.31641V9.18555H48.6738C48.7715 10.0156 49.8506 10.8066 51.5547 11.0117L51.1445 11.8711C49.5625 11.6807 48.3955 10.9824 47.9219 10.0254C47.4482 10.9775 46.291 11.6807 44.709 11.8711L44.3086 11.0117C46.0127 10.8066 47.0771 10.0156 47.1797 9.18555H44.6406V8.31641H51.2324ZM51.9648 12.3594V13.2383H48.5566V14.8496H47.4824V13.2383H43.8984V12.3594H51.9648ZM51.0762 15.6895V16.5684H44.875V14.0391H45.959V15.6895H51.0762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 0.796875V0.1891H0.212538V0.796875H0.820312ZM0.820312 1.40465H87.1243V0.1891H0.820312V1.40465ZM1.42809 22.6768V0.796875H0.212538V22.6768H1.42809Z",
    fill: "#B9B9B9",
    mask: "url(#path-3-inside-1_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.126 0.796875H173.43V22.6768H87.126V0.796875Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.126 0.796875H173.43V22.6768H87.126V0.796875Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.118 12.8379V13.7168H116.612V16.7344H115.538V13.7168H112.071V12.8379H120.118ZM119.376 8.41406V9.27344H116.729C116.793 10.2402 117.955 11.168 119.698 11.3926L119.308 12.2422C117.804 12.0322 116.632 11.3438 116.095 10.3867C115.558 11.3438 114.386 12.0322 112.901 12.2422L112.491 11.3926C114.225 11.168 115.387 10.2402 115.47 9.27344H112.813V8.41406H119.376ZM123.575 8.53125C124.972 8.52148 125.997 9.41016 126.007 10.6602C125.997 11.9199 124.972 12.7988 123.575 12.7988C122.188 12.7988 121.153 11.9199 121.153 10.6602C121.153 9.41016 122.188 8.52148 123.575 8.53125ZM123.575 9.46875C122.804 9.46875 122.228 9.92773 122.228 10.6602C122.228 11.4023 122.804 11.8516 123.575 11.8516C124.356 11.8516 124.942 11.4023 124.942 10.6602C124.942 9.92773 124.356 9.46875 123.575 9.46875ZM128.067 7.91602V16.7539H126.983V7.91602H128.067ZM120.753 14.0195C122.345 14.0195 124.552 14 126.456 13.7266L126.544 14.5176C124.562 14.8984 122.442 14.9082 120.89 14.9082L120.753 14.0195ZM139.093 7.91602V12.4668H138.009V7.91602H139.093ZM139.093 12.8379V15.1133H134.269V15.8066H139.376V16.666H133.194V14.3223H138.019V13.6875H133.175V12.8379H139.093ZM136.905 8.48242V9.32227H136.114V11.2461C136.515 11.2119 136.905 11.1729 137.276 11.1289L137.325 11.9102C135.567 12.1836 133.536 12.2422 131.993 12.2422L131.876 11.3828C132.193 11.3828 132.53 11.3779 132.882 11.373V9.32227H132.11V8.48242H136.905ZM133.927 11.3535C134.308 11.3438 134.693 11.3291 135.079 11.3047V9.32227H133.927V11.3535ZM148.438 14.7812V15.6699H140.372V14.7812H142.237V12.5449C141.534 12.1445 141.109 11.5146 141.114 10.7285C141.104 9.32227 142.491 8.39453 144.386 8.39453C146.29 8.39453 147.677 9.32227 147.677 10.7285C147.677 11.5 147.267 12.1201 146.583 12.5254V14.7812H148.438ZM144.386 9.25391C143.067 9.25391 142.169 9.81055 142.179 10.7285C142.169 11.6367 143.067 12.2031 144.386 12.2031C145.704 12.2031 146.612 11.6367 146.612 10.7285C146.612 9.81055 145.704 9.25391 144.386 9.25391ZM143.312 14.7812H145.479V12.9355C145.143 13.0137 144.776 13.0527 144.386 13.0527C144.005 13.0527 143.644 13.0137 143.312 12.9453V14.7812Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.126 0.796875V0.1891H86.5182V0.796875H87.126ZM87.126 1.40465H173.43V0.1891H87.126V1.40465ZM87.7338 22.6768V0.796875H86.5182V22.6768H87.7338Z",
    fill: "#B9B9B9",
    mask: "url(#path-6-inside-2_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-3_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.821 0.796875H302.277V22.6768H172.821V0.796875Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.821 0.796875H302.277V22.6768H172.821V0.796875Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.821 0.796875V0.1891H172.214V0.796875H172.821ZM172.821 1.40465H302.277V0.1891H172.821V1.40465ZM173.429 22.6768V0.796875H172.214V22.6768H173.429Z",
    fill: "#B9B9B9",
    mask: "url(#path-9-inside-3_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-4_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.427 0.796875H302.275V22.6768H173.427V0.796875Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.427 0.796875H302.275V22.6768H173.427V0.796875Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.837 7.96289V8.49023C224.827 9.0957 224.827 9.96484 224.622 11.0879L223.548 10.9902C223.719 10.0771 223.753 9.40332 223.772 8.86133H220.335V7.96289H224.837ZM222.61 9.97461V11.7324C223.523 11.6982 224.461 11.6299 225.315 11.5078L225.374 12.2891C223.538 12.6211 221.458 12.6504 219.905 12.6602L219.808 11.791C220.33 11.7861 220.916 11.7812 221.536 11.7715V9.97461H222.61ZM226.946 7.30859V10.0625H228.089V10.9707H226.946V13.9199H225.833V7.30859H226.946ZM227.229 15.082V15.9609H221.126V13.334H222.22V15.082H227.229ZM235.901 7.30859V16.1465H234.827V7.30859H235.901ZM233.187 8.08008V11.3906H230.149V13.168C231.541 13.1582 232.742 13.0898 234.114 12.8555L234.212 13.7441C232.708 14.0078 231.39 14.0566 229.808 14.0566H229.036V10.5312H232.083V8.95898H229.026V8.08008H233.187ZM246.927 7.30859V11.8594H245.843V7.30859H246.927ZM246.927 12.2305V14.5059H242.103V15.1992H247.21V16.0586H241.028V13.7148H245.853V13.0801H241.009V12.2305H246.927ZM244.739 7.875V8.71484H243.948V10.6387C244.349 10.6045 244.739 10.5654 245.11 10.5215L245.159 11.3027C243.401 11.5762 241.37 11.6348 239.827 11.6348L239.71 10.7754C240.027 10.7754 240.364 10.7705 240.716 10.7656V8.71484H239.944V7.875H244.739ZM241.761 10.7461C242.142 10.7363 242.527 10.7217 242.913 10.6973V8.71484H241.761V10.7461ZM256.272 14.1738V15.0625H248.206V14.1738H250.071V11.9375C249.368 11.5371 248.943 10.9072 248.948 10.1211C248.938 8.71484 250.325 7.78711 252.22 7.78711C254.124 7.78711 255.511 8.71484 255.511 10.1211C255.511 10.8926 255.101 11.5127 254.417 11.918V14.1738H256.272ZM252.22 8.64648C250.901 8.64648 250.003 9.20312 250.013 10.1211C250.003 11.0293 250.901 11.5957 252.22 11.5957C253.538 11.5957 254.446 11.0293 254.446 10.1211C254.446 9.20312 253.538 8.64648 252.22 8.64648ZM251.146 14.1738H253.313V12.3281C252.977 12.4062 252.61 12.4453 252.22 12.4453C251.839 12.4453 251.478 12.4062 251.146 12.3379V14.1738Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.427 1.40465H302.275V0.1891H173.427V1.40465Z",
    fill: "#B9B9B9",
    mask: "url(#path-11-inside-4_1193_4040)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1193_4040)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 21.8799,
    transform: "translate(0.820312 22.6777)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-5_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 22.6777H43.8855V44.5576H0.820312V22.6777Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 22.6777H43.8855V44.5576H0.820312V22.6777Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3564 35.8125C19.3564 34.3477 20.6455 34.0195 21.7471 33.9375C22.1514 33.9082 23.1826 33.8555 23.4697 33.8438V33.3281C23.4697 32.5195 22.9893 32.0508 22.0283 32.0508C21.2197 32.0508 20.7393 32.4258 20.5986 32.9062H19.5439C19.6729 31.8867 20.6689 31.1719 22.0752 31.1719C22.9072 31.1719 24.4658 31.418 24.4658 33.4219V37.6172H23.4697V36.75H23.4229C23.2119 37.1836 22.626 37.7695 21.5244 37.7695C20.3174 37.7695 19.3564 37.0547 19.3564 35.8125ZM20.3643 35.8594C20.3643 36.5273 20.9268 36.8672 21.7002 36.8672C22.8369 36.8672 23.4697 36.1055 23.4697 35.3086V34.6641C23.1709 34.6875 22.1689 34.7637 21.8643 34.7812C20.9502 34.8398 20.3643 35.168 20.3643 35.8594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 22.6777V22.07H0.212538V22.6777H0.820312ZM0.820312 23.2855H43.8855V22.07H0.820312V23.2855ZM1.42809 44.5576V22.6777H0.212538V44.5576H1.42809Z",
    fill: "#B9B9B9",
    mask: "url(#path-14-inside-5_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-6_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8906 22.6777H86.9558V44.5576H43.8906V22.6777Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.8906 22.6777H86.9558V44.5576H43.8906V22.6777Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3604 37.6172V29.1328H63.3682V32.2617H63.4502C63.6729 31.9219 64.0479 31.1719 65.29 31.1719C66.8838 31.1719 68.0088 32.4375 68.0088 34.4531C68.0088 36.4688 66.8838 37.7461 65.3018 37.7461C64.083 37.7461 63.6729 36.9961 63.4502 36.6445H63.333V37.6172H62.3604ZM63.3447 34.4297C63.3447 35.8594 63.9893 36.8438 65.1494 36.8438C66.3564 36.8438 66.9893 35.7891 66.9893 34.4297C66.9893 33.1055 66.3799 32.0742 65.1494 32.0742C63.9775 32.0742 63.3447 33.0234 63.3447 34.4297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8906 22.6777V22.07H43.2829V22.6777H43.8906ZM43.8906 23.2855H86.9558V22.07H43.8906V23.2855ZM44.4984 44.5576V22.6777H43.2829V44.5576H44.4984Z",
    fill: "#B9B9B9",
    mask: "url(#path-17-inside-6_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-7_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.9502 22.6777H130.015V44.5576H86.9502V22.6777Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.9502 22.6777H130.015V44.5576H86.9502V22.6777Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.393 37.7461C106.588 37.7461 105.486 36.375 105.486 34.4648C105.486 32.5312 106.635 31.1719 108.369 31.1719C109.729 31.1719 110.736 31.9688 110.9 33.1758H109.893C109.752 32.5898 109.236 32.0625 108.393 32.0625C107.256 32.0625 106.494 33 106.494 34.4297C106.494 35.9062 107.232 36.8438 108.393 36.8438C109.143 36.8438 109.717 36.4453 109.893 35.7422H110.9C110.736 36.8789 109.811 37.7461 108.393 37.7461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9502 22.6777V22.07H86.3424V22.6777H86.9502ZM86.9502 23.2855H130.015V22.07H86.9502V23.2855ZM87.558 44.5576V22.6777H86.3424V44.5576H87.558Z",
    fill: "#B9B9B9",
    mask: "url(#path-20-inside-7_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-8_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.012 22.6777H173.077V44.5576H130.012V22.6777Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.012 22.6777H173.077V44.5576H130.012V22.6777Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.755 37.7461C149.173 37.7461 148.048 36.4688 148.048 34.4531C148.048 32.4375 149.173 31.1719 150.767 31.1719C151.997 31.1719 152.396 31.9219 152.606 32.2617H152.677V29.1328H153.696V37.6172H152.712V36.6445H152.606C152.384 36.9961 151.974 37.7461 150.755 37.7461ZM150.896 36.8438C152.056 36.8438 152.712 35.8594 152.712 34.4297C152.712 33.0234 152.079 32.0742 150.896 32.0742C149.677 32.0742 149.067 33.1055 149.067 34.4297C149.067 35.7891 149.688 36.8438 150.896 36.8438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.012 22.6777V22.07H129.404V22.6777H130.012ZM130.012 23.2855H173.077V22.07H130.012V23.2855ZM130.619 44.5576V22.6777H129.404V44.5576H130.619Z",
    fill: "#B9B9B9",
    mask: "url(#path-23-inside-8_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-9_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.08 22.6777H216.146V44.5576H173.08V22.6777Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.08 22.6777H216.146V44.5576H173.08V22.6777Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.594 37.7461C192.754 37.7461 191.617 36.4453 191.617 34.4883C191.617 32.5312 192.766 31.1719 194.5 31.1719C195.836 31.1719 197.242 31.9922 197.242 34.3477V34.7695H192.625C192.672 36.1172 193.457 36.8555 194.594 36.8555C195.355 36.8555 195.836 36.5273 196.07 36.1289H197.148C196.844 37.0898 195.906 37.7461 194.594 37.7461ZM192.637 33.9141H196.223C196.223 32.8477 195.543 32.0625 194.5 32.0625C193.398 32.0625 192.695 32.9297 192.637 33.9141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.08 22.6777V22.07H172.472V22.6777H173.08ZM173.08 23.2855H216.146V22.07H173.08V23.2855ZM173.688 44.5576V22.6777H172.472V44.5576H173.688Z",
    fill: "#B9B9B9",
    mask: "url(#path-26-inside-9_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-10_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.15 22.6777H259.216V44.5576H216.15V22.6777Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.15 22.6777H259.216V44.5576H216.15V22.6777Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.84 31.2539V32.0977H237.434V37.6172H236.414V32.0977H235.395V31.2539H236.414V30.3867C236.414 29.3555 237.105 28.7344 238.23 28.7344C238.477 28.7344 238.77 28.7695 238.98 28.8047V29.707C238.77 29.6719 238.582 29.6602 238.453 29.6602C237.75 29.6602 237.434 29.9531 237.434 30.6094V31.2539H238.84Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.15 22.6777V22.07H215.543V22.6777H216.15ZM216.15 23.2855H259.216V22.07H216.15V23.2855ZM216.758 44.5576V22.6777H215.543V44.5576H216.758Z",
    fill: "#B9B9B9",
    mask: "url(#path-29-inside-10_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-11_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.212 22.6777H302.278V44.5576H259.212V22.6777Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.212 22.6777H302.278V44.5576H259.212V22.6777Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.632 40.1367C279.097 40.1367 278.054 39.4688 277.937 38.2852H278.991C279.132 38.9297 279.729 39.2578 280.632 39.2578C281.722 39.2578 282.39 38.7891 282.39 37.7344V36.4453H282.308C282.097 36.7969 281.687 37.5234 280.456 37.5234C278.909 37.5234 277.749 36.3516 277.749 34.3477C277.749 32.3906 278.874 31.1719 280.468 31.1719C281.698 31.1719 282.097 31.9219 282.331 32.2617H282.413V31.2539H283.397V37.793C283.397 39.4336 282.179 40.1367 280.632 40.1367ZM280.597 36.6211C281.757 36.6211 282.413 35.7891 282.413 34.3828C282.413 33.0234 281.78 32.0742 280.597 32.0742C279.378 32.0742 278.769 33.1055 278.769 34.3828C278.769 35.707 279.39 36.6211 280.597 36.6211Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.212 22.6777V22.07H258.604V22.6777H259.212ZM259.212 23.2855H302.278V22.07H259.212V23.2855ZM259.82 44.5576V22.6777H258.604V44.5576H259.82Z",
    fill: "#B9B9B9",
    mask: "url(#path-32-inside-11_1193_4040)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1193_4040)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 37.682,
    transform: "translate(0.820312 44.5566)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-12_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 44.5566H44.5801V82.2387H0.820312V44.5566Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 44.5566H44.5801V82.2387H0.820312V44.5566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.998,
    cy: 63.0927,
    r: 9.11662,
    stroke: "#646464",
    strokeWidth: 1.82332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 44.5566V43.9489H0.212538V44.5566H0.820312ZM44.5801 44.5566H45.1879V43.9489H44.5801V44.5566ZM0.820312 45.1644H44.5801V43.9489H0.820312V45.1644ZM43.9723 44.5566V82.2387H45.1879V44.5566H43.9723ZM1.42809 82.2387V44.5566H0.212538V82.2387H1.42809Z",
    fill: "#B9B9B9",
    mask: "url(#path-35-inside-12_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-38-inside-13_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9707 44.5566H87.1227V45.1644H43.9707V44.5566Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.9707 44.5566H87.1227V45.1644H43.9707V44.5566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9707 45.1644H87.1227V43.9489H43.9707V45.1644Z",
    fill: "#B9B9B9",
    mask: "url(#path-38-inside-13_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-40-inside-14_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1143 44.5566H172.81V82.2387H87.1143V44.5566Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.1143 44.5566H172.81V82.2387H87.1143V44.5566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1143 44.5566V43.9489H86.5065V44.5566H87.1143ZM87.1143 45.1644H172.81V43.9489H87.1143V45.1644ZM87.722 82.2387V44.5566H86.5065V82.2387H87.722Z",
    fill: "#B9B9B9",
    mask: "url(#path-40-inside-14_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-42-inside-15_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.1143 44.5566H130.266V82.2387H87.1143V44.5566Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.1143 44.5566H130.266V82.2387H87.1143V44.5566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.679,
    cy: 63.0927,
    r: 9.11662,
    stroke: "#646464",
    strokeWidth: 1.82332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.681 56.4502C110.084 56.4502 111.451 56.8942 112.585 57.7187C113.72 58.5432 114.565 59.7057 114.998 61.0397C115.432 62.3738 115.432 63.8108 114.998 65.1448C114.565 66.4788 113.72 67.6414 112.585 68.4658L108.681 63.0923L108.681 56.4502Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.228,
    cy: 63.0927,
    r: 9.11662,
    stroke: "#646464",
    strokeWidth: 1.82332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.231 56.4502C152.634 56.4502 154 56.8942 155.135 57.7187C156.27 58.5432 157.115 59.7057 157.548 61.0397C157.981 62.3738 157.981 63.8108 157.548 65.1448C157.115 66.4788 156.27 67.6414 155.135 68.4658L151.231 63.0923L151.231 56.4502Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1143 45.1644H130.266V43.9489H87.1143V45.1644Z",
    fill: "#B9B9B9",
    mask: "url(#path-42-inside-15_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-48-inside-16_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.821 44.5566H215.973V82.2387H172.821V44.5566Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.821 44.5566H215.973V82.2387H172.821V44.5566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.398,
    cy: 63.0927,
    r: 9.11662,
    stroke: "#646464",
    strokeWidth: 1.82332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.401 56.4502C195.273 56.4502 196.137 56.622 196.943 56.9558C197.749 57.2896 198.481 57.7788 199.098 58.3956C199.714 59.0124 200.204 59.7446 200.537 60.5504C200.871 61.3563 201.043 62.22 201.043 63.0923C201.043 63.9645 200.871 64.8282 200.537 65.6341C200.204 66.4399 199.714 67.1722 199.098 67.7889C198.481 68.4057 197.749 68.895 196.943 69.2288C196.137 69.5626 195.273 69.7344 194.401 69.7344L194.401 63.0923L194.401 56.4502Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.821 44.5566V43.9489H172.214V44.5566H172.821ZM172.821 45.1644H215.973V43.9489H172.821V45.1644ZM173.429 82.2387V44.5566H172.214V82.2387H173.429Z",
    fill: "#B9B9B9",
    mask: "url(#path-48-inside-16_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-52-inside-17_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.972 44.5566H259.124V82.2387H215.972V44.5566Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.972 44.5566H259.124V82.2387H215.972V44.5566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.555,
    cy: 63.0927,
    r: 9.11662,
    stroke: "#646464",
    strokeWidth: 1.82332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.557 56.4502C238.605 56.4502 239.639 56.6982 240.573 57.1741C241.507 57.65 242.315 58.3401 242.931 59.1881C243.547 60.0361 243.954 61.0179 244.117 62.0532C244.281 63.0885 244.198 64.1479 243.874 65.1448C243.55 66.1417 242.995 67.0478 242.254 67.7889C241.513 68.5301 240.607 69.0854 239.61 69.4093C238.613 69.7332 237.553 69.8166 236.518 69.6526C235.483 69.4886 234.501 69.082 233.653 68.4658L237.557 63.0923L237.557 56.4502Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.972 44.5566V43.9489H215.364V44.5566H215.972ZM215.972 45.1644H259.124V43.9489H215.972V45.1644ZM216.579 82.2387V44.5566H215.364V82.2387H216.579Z",
    fill: "#B9B9B9",
    mask: "url(#path-52-inside-17_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-56-inside-18_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.127 44.5566H302.279V82.2387H259.127V44.5566Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.127 44.5566H302.279V82.2387H259.127V44.5566Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.705,
    cy: 63.0927,
    r: 9.11662,
    stroke: "#646464",
    strokeWidth: 1.82332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.708 56.4502C281.932 56.4502 283.134 56.7889 284.178 57.4289C285.222 58.069 286.07 58.9854 286.626 60.0768C287.182 61.1683 287.425 62.3922 287.329 63.6134C287.233 64.8346 286.801 66.0054 286.081 66.9964C285.361 67.9874 284.381 68.76 283.249 69.2288C282.118 69.6975 280.878 69.8442 279.668 69.6526C278.459 69.461 277.325 68.9385 276.394 68.143C275.462 67.3474 274.769 66.3098 274.391 65.1448L280.708 63.0923L280.708 56.4502Z",
    fill: "#F2CA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.127 44.5566V43.9489H258.519V44.5566H259.127ZM259.127 45.1644H302.279V43.9489H259.127V45.1644ZM259.735 82.2387V44.5566H258.519V82.2387H259.735Z",
    fill: "#B9B9B9",
    mask: "url(#path-56-inside-18_1193_4040)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5488,
    cy: 63.0927,
    r: 9.11662,
    stroke: "#646464",
    strokeWidth: 1.82332
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1934 63.0933C72.1934 62.221 72.0216 61.3573 71.6878 60.5515C71.354 59.7456 70.8647 59.0134 70.248 58.3966C69.6312 57.7798 68.899 57.2906 68.0931 56.9568C67.2873 56.623 66.4235 56.4512 65.5513 56.4512L65.5513 63.0933H72.1934Z",
    fill: "#F2CA88"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1193_4040)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 56.523,
    transform: "translate(0.820312 82.2383)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-62-inside-19_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 82.2383H43.9723V104.118H0.820312V82.2383Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 82.2383H43.9723V104.118H0.820312V82.2383Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.820312 82.2383V81.6305H0.212538V82.2383H0.820312ZM0.820312 82.8461H43.9723V81.6305H0.820312V82.8461ZM1.42809 104.118V82.2383H0.212538V104.118H1.42809Z",
    fill: "#B9B9B9",
    mask: "url(#path-62-inside-19_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-64-inside-20_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9707 82.2383H87.1227V138.761H43.9707V82.2383Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.9707 82.2383H87.1227V138.761H43.9707V82.2383Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0957 113.864C53.7191 108.527 55.265 97.6723 56.4618 96.9473C56.7112 96.7459 57.2847 96.6452 57.5839 97.8536C57.9579 99.7668 58.8555 105.648 59.454 113.864C59.5786 116.684 60.0524 122.323 60.95 122.323C61.0747 122.524 61.9973 121.719 64.6902 116.885C65.1889 116.281 66.3358 115.496 66.9343 117.187C67.1836 117.59 67.9067 118.033 68.8043 116.583L70.3004 113.864C70.5497 113.361 71.2728 112.656 72.1705 113.864L73.2925 114.95C73.9159 115.554 75.6114 116.158 77.4067 113.741",
    stroke: "#66FCF1",
    strokeWidth: 1.08438,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.3557,
    y1: 114.153,
    x2: 80.3663,
    y2: 114.153,
    stroke: "black",
    strokeWidth: 0.162656,
    strokeLinecap: "round",
    strokeDasharray: "0.38 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9707 82.2383V81.6305H43.3629V82.2383H43.9707ZM43.9707 82.8461H87.1227V81.6305H43.9707V82.8461ZM44.5785 138.761V82.2383H43.3629V138.761H44.5785Z",
    fill: "#B9B9B9",
    mask: "url(#path-64-inside-20_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-68-inside-21_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.126 82.2383H130.278V138.761H87.126V82.2383Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.126 82.2383H130.278V138.761H87.126V82.2383Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.51,
    y1: 114.028,
    x2: 123.521,
    y2: 114.028,
    stroke: "black",
    strokeWidth: 0.162656,
    strokeLinecap: "round",
    strokeDasharray: "0.38 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4658 113.726C97.8886 107.188 99.0513 94.716 100.32 97.13C100.32 97.0294 100.447 97.1903 100.954 98.6387C101.06 98.5381 101.588 101.535 102.857 114.33C103.068 116.844 103.554 122.296 103.808 123.985C104.019 124.287 104.569 124.046 105.076 120.666C105.182 119.459 105.52 116.985 106.028 116.744C106.345 116.442 107.296 117.468 108.564 123.985C108.776 124.69 109.769 123.804 112.052 114.631C112.264 113.525 113.067 111.795 114.589 113.726C115.223 114.68 117.063 116.197 119.346 114.631",
    stroke: "#66FCF1",
    strokeWidth: 1.08438,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.126 82.2383V81.6305H86.5182V82.2383H87.126ZM87.126 82.8461H130.278V81.6305H87.126V82.8461ZM87.7338 138.761V82.2383H86.5182V138.761H87.7338Z",
    fill: "#B9B9B9",
    mask: "url(#path-68-inside-21_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-72-inside-22_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.276 82.2383H172.821V138.761H130.276V82.2383Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.276 82.2383H172.821V138.761H130.276V82.2383Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.864,
    y1: 113.887,
    x2: 167.874,
    y2: 113.887,
    stroke: "black",
    strokeWidth: 0.162656,
    strokeLinecap: "round",
    strokeDasharray: "0.38 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.433 113.397C142.737 108.129 143.466 97.5338 143.952 97.2907C144.256 96.4803 145.046 95.3458 145.775 97.2907C146.079 99.4179 146.748 105.617 146.991 113.397C146.991 116.942 147.173 123.972 147.903 123.729C148.004 124.134 148.632 124.276 150.334 121.602C150.638 121.298 151.428 121.298 152.157 123.729C152.461 123.83 153.129 123.243 153.373 120.082C153.575 117.55 154.163 112.485 154.892 112.485C155.297 112.08 156.29 111.756 157.019 113.701C157.424 114.308 158.721 115.159 160.666 113.701",
    stroke: "#66FCF1",
    strokeWidth: 1.08438,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.276 82.2383V81.6305H129.669V82.2383H130.276ZM130.276 82.8461H172.821V81.6305H130.276V82.8461ZM130.884 138.761V82.2383H129.669V138.761H130.884Z",
    fill: "#B9B9B9",
    mask: "url(#path-72-inside-22_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-76-inside-23_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.821 82.2383H215.973V138.761H172.821V82.2383Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.821 82.2383H215.973V138.761H172.821V82.2383Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.804,
    y1: 114.29,
    x2: 209.815,
    y2: 114.29,
    stroke: "black",
    strokeWidth: 0.162656,
    strokeLinecap: "round",
    strokeDasharray: "0.38 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.066 114.103C184.37 109.545 185.1 100.003 185.586 98.3008C185.89 97.1865 186.801 95.6266 188.017 98.3008C188.118 98.706 188.321 99.6379 188.321 100.124C188.422 106.607 188.868 119.694 189.84 120.181C190.245 120.485 191.238 120.302 191.967 117.142C192.17 116.737 192.697 116.352 193.183 118.053C193.386 119.168 193.973 122.065 194.702 124.739C195.108 125.144 196.04 125.286 196.526 122.612C196.931 119.472 197.924 113.07 198.653 112.583C199.159 111.976 200.476 111.611 201.692 115.015C202.198 115.521 203.576 116.048 205.035 114.103",
    stroke: "#66FCF1",
    strokeWidth: 1.08438,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.821 82.2383V81.6305H172.214V82.2383H172.821ZM172.821 82.8461H215.973V81.6305H172.821V82.8461ZM173.429 138.761V82.2383H172.214V138.761H173.429Z",
    fill: "#B9B9B9",
    mask: "url(#path-76-inside-23_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-80-inside-24_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.972 82.2383H259.124V138.761H215.972V82.2383Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.972 82.2383H259.124V138.761H215.972V82.2383Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.353,
    y1: 114.635,
    x2: 252.363,
    y2: 114.635,
    stroke: "black",
    strokeWidth: 0.162656,
    strokeLinecap: "round",
    strokeDasharray: "0.38 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.563 114.648C230.763 111.266 231.281 103.826 231.759 101.121C231.958 99.8912 232.596 97.4316 233.553 97.4316C234.15 97.4316 235.346 98.1695 235.346 101.121C235.446 106.45 235.705 117.231 235.944 117.723C236.243 118.747 237.08 120.551 238.036 119.567C238.534 119.362 239.531 119.69 239.531 122.642C240.029 124.179 241.205 125.901 241.922 120.49C242.121 117.723 242.998 112.312 244.911 112.804C245.309 112.804 246.286 113.296 247.003 115.263C247.203 115.468 247.84 115.632 248.797 114.648",
    stroke: "#66FCF1",
    strokeWidth: 1.08438,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.972 82.2383V81.6305H215.364V82.2383H215.972ZM215.972 82.8461H259.124V81.6305H215.972V82.8461ZM216.579 138.761V82.2383H215.364V138.761H216.579Z",
    fill: "#B9B9B9",
    mask: "url(#path-80-inside-24_1193_4040)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-84-inside-25_1193_4040",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.127 82.2383H302.279V138.761H259.127V82.2383Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.127 82.2383H302.279V138.761H259.127V82.2383Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.518,
    y1: 113.423,
    x2: 295.528,
    y2: 113.423,
    stroke: "black",
    strokeWidth: 0.162656,
    strokeLinecap: "round",
    strokeDasharray: "0.38 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.113 112.931C273.518 107.867 274.39 97.6154 274.633 97.1292C275.139 95.711 276.456 93.7864 277.672 97.4331C277.874 98.0409 278.401 102.782 278.887 116.882C278.988 117.692 279.434 119.131 280.407 118.401C281.014 117.692 282.291 117.307 282.534 121.44C282.635 123.871 283.324 127.7 285.269 123.567C286.18 120.225 288.065 113.418 288.308 112.931C288.814 112.02 290.253 110.865 291.954 113.539C292.258 113.843 293.048 114.147 293.778 112.931",
    stroke: "#66FCF1",
    strokeWidth: 1.08438,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.127 82.2383V81.6305H258.519V82.2383H259.127ZM259.127 82.8461H302.279V81.6305H259.127V82.8461ZM259.735 138.761V82.2383H258.519V138.761H259.735Z",
    fill: "#B9B9B9",
    mask: "url(#path-84-inside-25_1193_4040)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.41434,
    y1: 114.028,
    x2: 38.4249,
    y2: 114.028,
    stroke: "black",
    strokeWidth: 0.162656,
    strokeLinecap: "round",
    strokeDasharray: "0.38 0.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8154 114.059C12.0955 109.289 12.9686 99.1687 14.2211 96.8547C14.2338 96.717 14.3509 96.975 14.7175 99.1086C15.0611 103.353 15.7408 112.286 15.7103 114.059C15.9267 117.365 16.5656 124.375 17.3904 125.967C17.5177 126.093 17.8868 125.892 18.345 124.089C18.8669 120.546 20.1932 113.255 21.3234 112.444C21.8453 111.893 22.9807 111.49 23.3472 114.285C23.4491 115.186 23.8513 116.959 24.6455 116.839C24.9255 116.877 25.7682 116.343 26.8984 113.909C27.3312 113.12 28.5786 112.114 30.1059 114.397C30.9333 115.462 33.1684 116.952 35.49 114.397",
    stroke: "#66FCF1",
    strokeWidth: 1.08438,
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.1242,
    y: 1.10076,
    width: 300.392,
    height: 137.392,
    rx: 1.69611,
    stroke: "#B9B9B9",
    strokeWidth: 0.607775
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1193_4040"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.820312,
    y: 0.796875,
    width: 301,
    height: 138,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1193_4040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301.456,
    height: 21.8799,
    fill: "white",
    transform: "translate(0.820312 0.796875)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1193_4040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 21.8799,
    fill: "white",
    transform: "translate(0.820312 22.6777)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1193_4040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 37.682,
    fill: "white",
    transform: "translate(0.820312 44.5566)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1193_4040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 301,
    height: 56.523,
    fill: "white",
    transform: "translate(0.820312 82.2383)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.b0cfa7fac2cdbac67d7b7bcc4ab386df.svg";
export { ForwardRef as ReactComponent };